import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '@/views/Home.vue'
import Input from '@/views/Input.vue'
import Output from '@/views/Output.vue'
import About from '@/views/About.vue'
import NotFound from '../components/error-pages/NotFound'

import { hasEditor } from '@/helpers/env'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },
  {
    path: '/input',
    name: 'input',
    component: Input
  },
  {
    path: '/output',
    name: 'output',
    component: Output
  },
  {
    path: '/about',
    name: 'about',
    component: About
  },
  {
    path: '*',
    component: NotFound
  }
]

if (hasEditor) {
  routes.push({
    path: '/editor',
    name: 'editor',
    component: () => import('@/views/Editor')
  })
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
